/**
 * These are currently configured to align/abstract out antd grid sizing
 * https://ant.design/components/grid/
 */

export const CONTENT_WIDTH = {
  max: 24,
  fiveSixths: 20,
  threeQuarters: 18,
  twoThirds: 16,
  half: 12,
  fiveTwelfths: 10,
  threeEighths: 9,
  oneThird: 8,
  oneQuarter: 6,
  oneSixth: 4,
  oneEight: 3,
  oneTwelfth: 2,
  single: 1,
  none: 0,
};
